import { map } from 'lodash';
import type { ITicketHomeLoanDetails } from './TicketHomeLoanDetails.interface';
import TicketLoanDetailsSplit from './TicketLoanDetailsSplit';

export default class TicketHomeLoanDetails implements ITicketHomeLoanDetails {
  lender: string;
  lenderOtherName: string;
  loanApplicationNumber: string;
  term: number;
  lvr: number;
  dealLoanDetailsSplit: Array<TicketLoanDetailsSplit>;
  lmiCapitalised: boolean;
  lmi: number;
  offset: boolean;
  netBanking: boolean;
  creditCard: boolean;
  creditCardLimit: number;

  static build = (data: ITicketHomeLoanDetails) => new TicketHomeLoanDetails(data);
  static blank = () => new TicketHomeLoanDetails();

  /**
   * Constructor
   * @param {ITicketHomeLoanDetails} data
   */
  constructor(data?: ITicketHomeLoanDetails) {
    this.lender = data?.lender || '';
    this.lenderOtherName = data?.lenderOtherName || '';
    this.loanApplicationNumber = data?.loanApplicationNumber || '';
    this.term = parseFloat(data?.term || 0);
    this.lvr = parseFloat(data?.lvr || 0);
    this.dealLoanDetailsSplit = map(
      data?.dealLoanDetailsSplit,
      (obj) => new TicketLoanDetailsSplit(obj)
    );
    this.lmiCapitalised = data?.lmiCapitalised === true;
    this.lmi = parseFloat(data?.lmi || 0);
    this.offset = data?.offset === true;
    this.netBanking = data?.netBanking === true;
    this.creditCard = data?.creditCard === true;
    this.creditCardLimit = parseFloat(data?.creditCardLimit || 0);
  }
}
